function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.79884 55.498C-3.29361 68.1638 2.79591 82.58 15.4002 87.6973L33.8416 41.8302C21.2373 36.7128 6.89129 42.8321 1.79884 55.498Z",
  fill: "url(#paint0_linear_52368_151471)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4587 64.1349C26.6387 78.6102 33.5982 95.0857 48.0031 100.934C62.4079 106.783 78.8034 99.7891 84.6233 85.3138L32.4587 64.1349Z",
  fill: "url(#paint1_linear_52368_151471)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M80.9998 0C99.0058 7.31049 107.705 27.905 100.43 45.9991C93.1553 64.0932 72.661 72.835 54.6549 65.5245L80.9998 0Z",
  fill: "url(#paint2_linear_52368_151471)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9143 27.3356C21.2793 16.4792 33.5759 11.2341 44.3795 15.6204C55.1831 20.0066 60.4027 32.3633 56.0378 43.2198L16.9143 27.3356Z",
  fill: "url(#paint3_linear_52368_151471)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52368_151471",
  x1: 103,
  y1: 51.5,
  x2: 0.00000135521,
  y2: 51.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_52368_151471",
  x1: 103,
  y1: 51.5,
  x2: 0.00000135521,
  y2: 51.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_52368_151471",
  x1: 103,
  y1: 51.5,
  x2: 0.00000135521,
  y2: 51.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_52368_151471",
  x1: 103,
  y1: 51.5,
  x2: 0.00000135521,
  y2: 51.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgDemex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemex);
export default __webpack_public_path__ + "static/media/Demex.b26f21bee4e27efc8c7fcfa504251b24.svg";
export { ForwardRef as ReactComponent };